module.exports = __webpack_public_path__ + "img/FW_TypePhone.1ec0fd24.jpg";